import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { getScrollBarWidth } from '#web-components/utils/common';

const DATE_PICKER_Z_INDEX = 1000000000;
const scrollBarWidth = getScrollBarWidth();

const styles = ({ colors, spacing }: Theme) => createStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: spacing(2),
    paddingBottom: spacing(2),
  },
  'react-datepicker__custom-header': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `0 ${spacing(1)}px`,
    '& .react-datepicker__custom-header__month': {
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      padding: 0,
    },
  },
  monthButtons: {
    margin: 0,
  },
  monthText: {
    margin: `0 ${spacing(1)}px`,
  },
  clearIndicator: {
    display: 'none',
  },
  yearPopper: {
    zIndex: DATE_PICKER_Z_INDEX + 1,
    right: 0,
    top: spacing(6),
    width: '100% !important',
  },
  yearInput: {
    '&&': {
      width: spacing(7),
    },
  },
  yearIcons: {
    width: spacing(1),
  },
  yearInputRoot: {
    '&&&&': {
      paddingRight: spacing(4),
    },
  },
  yearPaper: {
    borderTop: `2px solid ${colors.layout.divider300}`,
    boxShadow: 'none',
    borderRadius: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    '& > ul': {
      width: `${spacing(14) + scrollBarWidth}px`,
      maxHeight: spacing(36),
    },
  },
});

export default styles;
